"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrapiClient = void 0;
const strapi_auth_client_1 = require("./strapi-auth-client");
const http_1 = require("./service/http");
const strapi_query_builder_1 = require("./strapi-query-builder");
class StrapiClient {
    constructor(options) {
        this.debug = options.debug || false;
        this.httpClient = (0, http_1.getAxiosInstance)(options.url, options.apiToken);
        this.auth = this._initStrapiAuthClient(this.httpClient);
        this.normalizeData = options.normalizeData ? options.normalizeData : false;
        this.options = options;
        this.isNotUserContent = true;
    }
    /**
     * Perform a model operation.
     *
     * @param name The model name to operate on.
     */
    from(contentName) {
        contentName === 'users' ? (this.isNotUserContent = false) : (this.isNotUserContent = true);
        const url = `${this.options.url}/${contentName}`;
        return new strapi_query_builder_1.StrapiQueryBuilder(url, this.httpClient, this.isNotUserContent, this.normalizeData, this.debug);
    }
    /**
     *
     * @returns The registered Api URL
     */
    getApiUrl() {
        return this.options.url;
    }
    setToken(token) {
        this.httpClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
    removeToken() {
        delete this.httpClient.defaults.headers.common['Authorization'];
    }
    _initStrapiAuthClient(axiosInstance) {
        return new strapi_auth_client_1.StrapiAuthClient(axiosInstance, this.options);
    }
}
exports.StrapiClient = StrapiClient;
